import React from "react"
import { Link } from "gatsby"
import useGlobal from "../context/GlobalContext"

export default function NavLink({ children, to, ...props }) {
  const { currentRouteOption } = useGlobal()

  // Function to handle link prefix based on current language route option
  function handleTo(href) {
    return currentRouteOption.value === "en-in" ? href : `/${currentRouteOption.value}${href}`
  }

  return (
    <Link to={handleTo(to)} {...props}>
      {children}
    </Link>
  )
}
